import { type FC } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import styles from './Button.module.scss'
import { type ButtonProps } from './Button.interface'

export const Button: FC<ButtonProps> = ({
  variant = 'primary',
  link,
  linkTarget,
  children,
  size,
  round,
  type = 'button',
  disabled,
  ariaLabel,
  onClick,
  className
}) => {
  const theme = `
  ${styles.button}
  ${className ?? ''}
  ${variant !== undefined ? styles[variant] : ''}
  ${round !== undefined ? styles.round : ''}
  ${size !== undefined ? styles[size] : ''}`

  return link !== undefined
    ? (
      <Link href={link} target={linkTarget ?? ''} className={theme}>
        {children}
      </Link>
      )
    : (
      <button
        type={type}
        className={classNames(theme, {
          [styles['button-disabled']]: disabled

        })}
        disabled={disabled}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {children}
      </button>
      )
}
